import * as React from "react";
import { Text, useFieldState, useFieldApi } from "informed";
import { inputClasses } from "../validation/ValidationClasses";

export const TextBoxWithStaticPrefix = ({ field, ...props }) => {
    const fieldState = useFieldState(field);
    const fieldApi = useFieldApi(field);

    return (
        <>
            <div className="input-group">
                <span className="input-group-addon">{props.staticpart}</span>
                <Text
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    {...props}
                />
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );
}
